export default function AnnouncementBar() {
  return (
    <div
      data-testid="announcement-bar"
      className="w-full bg-forest text-white text-[10px] sm:text-[11px] md:text-xs tracking-[0.14em] uppercase"
    >
      <div className="container-x flex items-center justify-center gap-2 py-2 text-center">
        <span className="font-medium leading-tight">
          Transform with Yogasana · Pranayama · Meditation · Nutrition · Lifelong Habit Mastery
        </span>
      </div>
    </div>
  );
}
